// Application version and build info
export const APP_VERSION = '1.0.0';
export const APP_NAME = 'NAH44';
export const BUILD_DATE = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

// Contact links
export const SUPPORT_PHONE = '917842305029'; // NAH44 support number
export const WHATSAPP_SUPPORT = '919381971969'; // NAH44 WhatsApp support number (+91 93819 71969)

// Social media
export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61587032332146';
export const INSTAGRAM_URL = 'https://www.instagram.com/nah44.1991?igsh=MTk0Nnl0d2wybmpxNg==';
export const YOUTUBE_URL = 'https://youtube.com/@nah44-q4o5u?si=OXVZyEJ9hFP7jxqs';
